import { useContext, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _set from 'lodash/set';
import _get from 'lodash/get';
import { AppContext } from 'commons-ui';
import { UserReferralSegmentData } from 'pages/dashboard/referral/utils/types';
import { FORM_FIELD_KEYS } from './formConfig';
import useService from '../../../utils/useService';
import { hydrateFormData } from '../../../utils/formDataParser';

const useUpdateReferralSegment = () => {
	const [showLoader, setShowLoader] = useState(false);
	const history = useHistory();
	const location = useLocation();
	const data = hydrateFormData(_get(location, ['state', 'rowData']));
	const { showAlert } = useContext(AppContext);
	const { requestUpdateUserReferralSegment } = useService();

	const updateUserReferralSegment = async (userReferralSegmentData: UserReferralSegmentData) => {
		requestUpdateUserReferralSegment(userReferralSegmentData).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || res?.data?.externalMessage || 'Error occured while updating referral segment', {
						type: 'error'
					});
					setShowLoader(false);
					return;
				}
				showAlert('Referral segment for user updated');
				setShowLoader(false);
				history.goBack();
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.externalMessage || err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = async (submitData: any) => {
		setShowLoader(true);
		const payload = {} as UserReferralSegmentData;
		_set(payload, submitData[FORM_FIELD_KEYS.USER_DETAIL], (submitData[FORM_FIELD_KEYS.USER_ID] as string).trim());
		_set(payload, FORM_FIELD_KEYS.REFERRAL_SEGMENT, (submitData[FORM_FIELD_KEYS.REFERRAL_SEGMENT] as string).trim());
		await updateUserReferralSegment(payload);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data, showLoader, setShowLoader, handleFormCancel, handleFormSubmit };
};
export default useUpdateReferralSegment;
